import   { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import useFormErrorHighlight from '../../../hooks/useFormErrorHighlight'
import axios from 'axios';
import { Helmet } from 'react-helmet-async';


const SocialServiceClientBeneficiaryForm_ForUpdate = ({ personType, onChange, div_to_scroll_index, errorMessage, FormDatas }) => {

    const [divVoterVisibility, setDivVoterVisibility] = useState(false);
    const districtFieldName = `${personType}_district`;
    const districtErrorMessage = errorMessage && errorMessage.errors && errorMessage.errors[districtFieldName];

    const getFieldErrorMessage = useFormErrorHighlight(errorMessage);


    const [selectedDate, setSelectedDate] = useState(null);

    const [formData, setFormData] = useState({
        [`${personType}_fullname`]    : "",
        [`${personType}_isVoter`]     : "",
        [`${personType}_fullname`]    : "",
        [`${personType}_isVoter`]     : "",
        [`${personType}_voter_id`]    : "",
        [`${personType}_email`]       : "",
        [`${personType}_contact`]     : "",
        [`${personType}_gender`]      : "",
        [`${personType}_birthdate`]   : "",
        [`${personType}_address`]     : "",
        [`${personType}_district`]    : "",
        [`${personType}_municipality`]: "",
        [`${personType}_barangay`]    : "",
        [`${personType}_sitio`]       : "",
        [`${personType}_sector`]      : "",
        [`${personType}_father_name`] : "",
        [`${personType}_mother_name`] : "",
        [`${personType}_family_id`]   : "",
        [`${personType}_family_role`] : "",
    });
 
 
    // Update local state and notify parent about changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
        onChange(formData);
    };

    const handleDateChange = (date) => {
        date.setHours(0, 0, 0, 0);
        const formattedDate = date.toISOString().slice(0, 10);
        setSelectedDate(date);

        // Update form data
        setFormData(prevData => ({
            ...prevData,
            [`${personType}_birthdate`]: formattedDate
        }));
    };

 
    useEffect(() => {
        
        onChange(formData);
    }, [formData]);


    const [data, setData]             = useState([]);
    const [count, setCount]           = useState(0);
    const [searchTerm, setSearchTerm] = useState('')

    useEffect(() => {

        if (searchTerm !== "") {
            const delayDebounceFn = setTimeout(async () => {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/voters/?search=${searchTerm}`);
                setData(response.data.results);
                setCount(response.data.count)
                setDivVoterVisibility(true);
            }, 750)

            return () => clearTimeout(delayDebounceFn)
        }
        else {
            setData(null);
        }


    }, [searchTerm])


    const colors = ['danger', 'primary', 'success', 'info', 'warning'];




    // FOR LOCATION: DISTRICT , MUNICIPALITY , BARANGAY

    const [cachedData, setCachedData] = useState([]);
    useEffect(() => {
        const cachedDataString = localStorage.getItem('cachedData');
        if (cachedDataString) {
            const parsedCachedData = JSON.parse(cachedDataString);
            setCachedData(parsedCachedData);
        }
    }, []);



    const [districtList, setDistrictList] = useState([]);
    const [district, setDistrict]         = useState('');

    const [municipalityList, setMunicipalityList] = useState([]);
    const [municipality, setMunicipality]         = useState('');

    const [barangayList, setBarangayList] = useState([]);
    const [barangay, setBarangay]         = useState('');


    useEffect(() => {
        console.log(FormDatas);
        setDistrict(FormDatas[`${personType}_district`]);
        setMunicipality(FormDatas[`${personType}_municipality`]);
        setBarangay(FormDatas[`${personType}_barangay`]);
    }, [FormDatas]);



    useEffect(() => {
        // GETTING ALL DISTRICTS ONLY
        const uniqueDistricts = [...new Set(cachedData.map(location => location.location_district))];

        const sortedDistricts = uniqueDistricts.sort((a, b) => {
            const numA = parseInt(a.match(/\d+/)[0]);
            const numB = parseInt(b.match(/\d+/)[0]);
            return numA - numB;
        });

        setDistrictList(sortedDistricts);
    }, [cachedData]);



    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        if (district && municipality) {
            const filteredLocations = cachedData.filter(location =>
                location.location_district === district && location.location_municipality === municipality
            );
            setFilteredData(filteredLocations);
        }
    }, [district, municipality]);



    const handleDistrictChange = (selectedDistrict) => {

        setMunicipalityList([]);
        setBarangayList([]);
        setMunicipality('');
        setBarangay('');


        setDistrict(selectedDistrict);
        const municipalities = cachedData
            .filter(location => location.location_district === selectedDistrict)
            .map(location => location.location_municipality)
            .sort((a, b) => a.localeCompare(b));

        const uniqueMunicipalities = [...new Set(municipalities)];

        setMunicipalityList(uniqueMunicipalities);
    };

    const handleMunicipalityChange = (selectedMunicipality) => {


        setMunicipality(selectedMunicipality);

        const barangays = cachedData
            .filter(location => location.location_district === district && location.location_municipality === selectedMunicipality)
            .map(location => location.location_barangay)
            .sort((a, b) => a.localeCompare(b));

        const uniqueBarangays = [...new Set(barangays)];


        setBarangay('');
        setBarangayList([]);
        setBarangayList(uniqueBarangays);
    };

    const handleBarangayChange = (selectedBarangay) => {
        setBarangay(selectedBarangay);
    };


    const handleRowClick = (rowData) => {
        setDivVoterVisibility(false)
        // Update form data with the clicked row's data

        setMunicipalityList([]);
        setBarangayList([]);

        setMunicipality('');
        setBarangay('');


        setDistrict(rowData.voter_district);
        setMunicipality(rowData.voter_municipality);
        setBarangay(rowData.voter_barangay);


        setFormData({
            ...formData,
            [`${personType}_voter_id`]                     : rowData.voter_id ?? "",
            [`${personType}_fullname`]                     : rowData.voter_name ?? "",
            [`${personType}_address`]                      : rowData.voter_address ?? "",
            [`${personType}_gender`]                       : rowData.voter_gender ?? "",
            [`${personType}_birthdate`]                    : rowData.voter_birthday ?? "",
            [`${personType}_district`]                     : rowData.voter_district ?? "",
            [`${personType}_municipality`]                 : rowData.voter_municipality ?? "",
            [`${personType}_barangay`]                     : rowData.voter_barangay ?? "",
            [`${personType}_sitio`]                        : rowData.voter_sitio ?? "",
            [`${personType}_contact`]                      : rowData.voter_contact ?? "",
            [`${personType}_email`]                        : rowData.voter_fb_email ?? "",
            [`${personType}_isVoter`]                      : rowData.isVoter ?? "",
            [`${personType}_household_id`]                 : rowData.voter_household_id ?? "",
            [`${personType}_household_role`]               : rowData.voter_household_role ?? "",
            [`${personType}_government_position`]          : rowData.voter_government_position ?? "",
            [`${personType}_voter_cluster_number`]         : rowData.voter_cluster_number ?? "",
            [`${personType}_voter_clustered_polling_place`]: rowData.voter_clustered_polling_place ?? "",
            [`${personType}_voter_clustered_precinct`]     : rowData.voter_clustered_precinct ?? "",
            [`${personType}_voter_id_status`]              : rowData.voter_id_status ?? "",
            [`${personType}_voter_image_path`]             : rowData.voter_image_path ?? "",
            [`${personType}_voter_leader`]                 : rowData.voter_leader ?? "",
            [`${personType}_voter_org`]                    : rowData.voter_org ?? "",
            [`${personType}_voter_org_2`]                  : rowData.voter_org_2 ?? "",
            [`${personType}_voter_poll_watcher_workers`]   : rowData.voter_poll_watcher_workers ?? "",
            [`${personType}_voter_religion`]               : rowData.voter_religion ?? "",
            [`${personType}_voter_sector`]                 : rowData.voter_sector ?? "",
            [`${personType}_voter_status`]                 : rowData.voter_status ?? "",
            [`${personType}_voter_structure_code`]         : rowData.voter_structure_code ?? "",
            [`${personType}_voter_structure_name`]         : rowData.voter_structure_name ?? "",
            [`${personType}_voter_vital_status`]           : rowData.voter_vital_status ?? "",
            [`${personType}_voter_working_status`]         : rowData.voter_working_status ?? "",

        });


        handleDistrictChange(rowData.voter_district);
        handleMunicipalityChange(rowData.voter_municipality);
        handleBarangayChange(rowData.voter_barangay);

    };

    useEffect(() => {
        handleDistrictChange(district);
    }, [district]);

    useEffect(() => {
        handleMunicipalityChange(municipality);
    }, [municipality]);

    useEffect(() => {
        // Handle barangay change
        handleBarangayChange(barangay);
    }, [barangay]);


    return (
        <>
            <Helmet>
                <link rel="stylesheet" href="/iusevolutione/assets/vendor/css/pages/app-chat.css" />
            </Helmet>
            <div id={`div_to_scroll_${div_to_scroll_index}`} className="card mb-4"  >
                <div className="card-header">
                    <h5 className="card-title m-0 text-primary">{personType.toUpperCase()} DETAILS</h5>
                </div>
                <div className="card-body">



                    <div className="row mb-3 g-3">





                        <div className="col-12">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_search`}>Search Voter</label>
                            <div className="input-group">
                                <input type="search" className="form-control" id={`${personType}_search`} name={`${personType}_search`} onChange={(e) => setSearchTerm(e.target.value)} placeholder="Voter name..." />
                                <button className="btn btn-outline-primary" type="button" id="button-addon2">Clear</button>
                            </div>



                            <div className={ divVoterVisibility ? 'd-block':'d-none' }>

                                {data && count == 0 ?
                                    <div className="list-group mt-1">
                                        <li className="list-group-item list-group-item-action d-flex justify-content-between">
                                            <div className="li-wrapper d-flex justify-content-start align-items-center">
                                                <div className="list-content text-info">
                                                    NO DATA FOUND
                                                </div>
                                            </div>
                                        </li>
                                    </div>
                                    :
                                    data && data.map((row, index) => (
                                        <div key={index} className="list-group mt-1">
                                            <button type="button" className="list-group-item list-group-item-action d-flex justify-content-between" onClick={() => handleRowClick(row)}>

                                                <table className='w-100'>
                                                    <tbody>
                                                        <tr>
                                                            <td width="250">
                                                                <div className="li-wrapper d-flex  align-items-center">

                                                                    {row.voter_image_path ?
                                                                        <img src={row.voter_image_path} alt="User Image" className="rounded-circle me-3 w-px-50"></img>
                                                                        :
                                                                        <div className="avatar avatar-sm me-3">
                                                                            <span className={`avatar-initial rounded-circle bg-label-${colors[index % colors.length]}`}>{row.voter_name[0].toUpperCase()}</span>
                                                                        </div>
                                                                    }

                                                                    <div className="list-content">
                                                                        <h6 className="mb-1">{row.voter_name?.toUpperCase()}</h6>
                                                                        <small className="text-muted">Birthday: {row.voter_birthday}</small>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td width="150">
                                                                <div className="list-content  text-center ">
                                                                    <h6 className="mb-1">{row.voter_municipality}</h6>
                                                                    <small className="text-muted">Municipality</small>
                                                                </div>
                                                            </td>
                                                            <td width="150">
                                                                <div className="list-content  text-center ">
                                                                    <h6 className="mb-1">{row.voter_barangay}</h6>
                                                                    <small className="text-muted">Barangay</small>
                                                                </div>
                                                            </td>
                                                            <td width="150">
                                                                <div className="list-content  text-center ">
                                                                    <h6 className="mb-1">{row.voter_precinct_no}</h6>
                                                                    <small className="text-muted">Precinct</small>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>



                                            </button>
                                        </div>
                                    ))}

                            </div>


                        </div>


                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-12">
                            <div className="divider divider-primary">
                                <div className="divider-text">OR</div>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_fullname`}>Enter Fullname</label>
                            <input type="text" className="form-control" id={`${personType}_fullname`} name={`${personType}_fullname`} value={FormDatas[`${personType}_fullname`]} onChange={handleChange}
                                placeholder="last, first middle suffix" aria-label="settings Details"
                                style={{ borderColor: getFieldErrorMessage(`${personType}_fullname`) }} />
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_voter_id`}>CVL ID</label>
                            <input type="text" className="form-control" id={`${personType}_voter_id`} name={`${personType}_voter_id`} value={FormDatas[`${personType}_voter_id`]} onChange={handleChange} />
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_email`}>Email</label>
                            <input type="email" className="form-control" id={`${personType}_email`} name={`${personType}_email`} value={FormDatas[`${personType}_email`]} onChange={handleChange} placeholder="john@gmail.com" aria-label="email" />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_contact`}>Contact</label>
                            <input type="number" id={`${personType}_contact`} name={`${personType}_contact`} value={FormDatas[`${personType}_contact`]} onChange={handleChange} className="form-control" placeholder="Contact" min={0} max={999999} />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_gender`}>Gender</label>
                            <select id={`${personType}_gender`} name={`${personType}_gender`} value={FormDatas[`${personType}_gender`]} onChange={handleChange} className="select2 form-select" data-placeholder="Gender">
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_birthdate`} >Birthday</label>
                            <DatePicker id={`${personType}_birthdate`}
                                name={`${personType}_birthdate`}
                                className='form-control  flatpickr-input active'
                                placeholderText='YYYY-MM-DD'
                                // selected={FormDatas[`${personType}_birthdate`]}
                                selected={selectedDate}
                                onChange={handleDateChange}
                                dateFormat="yyyy-MM-dd"
                                value={FormDatas[`${personType}_birthdate`]}
                            />
                        </div>



                        <div className="col-12">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_address`}>Address</label>
                            <input type="text" className="form-control" id={`${personType}_address`} value={FormDatas[`${personType}_address`]} onChange={handleChange} name={`${personType}_address`} placeholder="Address" aria-label="email" />
                        </div>


                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_district`}>District</label>
                            <select id={`${personType}_district`} name={`${personType}_district`} value={district} onChange={(e) => handleDistrictChange(e.target.value)} className="select2 form-select" data-placeholder="District" style={{ borderColor: districtErrorMessage ? 'red' : '' }}>
                                <option value="">Select District</option>
                                {districtList.map((district, index) => (
                                    <option key={index} value={district}>{district}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_municipality`}>Municipality</label>
                            <select id={`${personType}_municipality`} name={`${personType}_municipality`} value={municipality} onChange={(e) => handleMunicipalityChange(e.target.value)} className="select2 form-select" data-placeholder="Municipality">
                                <option value="">Select Municipality</option>
                                {municipalityList.map((municipality, index) => (
                                    <option key={index} value={municipality}>{municipality}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_barangay`}>Barangay</label>
                            <select id={`${personType}_barangay`} name={`${personType}_barangay`} value={barangay} onChange={(e) => handleBarangayChange(e.target.value)} className="select2 form-select" data-placeholder="Barangay">
                                <option value="">Select Barangay</option>
                                {barangayList.map((barangay, index) => (
                                    <option key={index} value={barangay}>{barangay}</option>
                                ))}
                            </select>
                        </div>


                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_sitio`}>Sitio</label>
                            <input type="text" className="form-control" id={`${personType}_sitio`} value={FormDatas[`${personType}_sitio`]} onChange={handleChange} name={`${personType}_sitio`} placeholder="Sitio" />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_sector`}>Sector</label>
                            <select id={`${personType}_sector`} name={`${personType}_sector`} value={FormDatas[`${personType}_sector`]} onChange={handleChange} className="select2 form-select" data-placeholder="Sector">
                                <option value=""></option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_father_name`}>Father's Name</label>
                            <input type="text" className="form-control" id={`${personType}_father_name`} name={`${personType}_father_name`} value={FormDatas[`${personType}_father_name`]} onChange={handleChange} placeholder="Father's Name" />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_mother_name`}>Mother's name</label>
                            <input type="text" className="form-control" id={`${personType}_mother_name`} name={`${personType}_mother_name`} value={FormDatas[`${personType}_mother_name`]} onChange={handleChange} placeholder="Mother's Name" />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_family_id`}>Family ID</label>
                            <input type="text" className="form-control" id={`${personType}_family_id`} name={`${personType}_family_id`} value={FormDatas[`${personType}_family_id`]} onChange={handleChange} placeholder="Family ID (optional)" />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_family_role`}>Role in the Family</label>
                            <select id={`${personType}_family_role`} name={`${personType}_family_role`} value={FormDatas[`${personType}_family_role`]} onChange={handleChange} className="select2 form-select" data-placeholder="Role">
                                <option value=""></option>
                                <option value="Head">Head</option>
                                <option value="Father">Father</option>
                                <option value="Mother">Mother</option>
                                <option value="Child">Child</option>
                            </select>
                        </div>




                    </div>

                </div>
            </div>


        </>
    );
}

export default SocialServiceClientBeneficiaryForm_ForUpdate;
